export const groupItems = <T>(items: Array<T>, groups: number): { [group: number]: Array<T> } => {
    const itemsPerGroup = Math.ceil(items.length / groups);

    const groupedItems = {};
    for (let i = 0; i < groups; i++) {
        groupedItems[i] = [];
    }

    let groupIndex = 0;
    items.forEach((item, index) => {
        if (index % itemsPerGroup === 0 && index > 0) {
            groupIndex++;
        }

        groupedItems[groupIndex].push(item);
    });
    return groupedItems;
};
